import axios from "axios";
// import { BASE_URL_FLORAHUB } from "../environment";

// let API_URL = BASE_URL_FLORAHUB;
const accessToken = localStorage.getItem("token");
export default async function callApi(endpoint, method = "GET", body, headers) {
  try {
    return await axios({
      method,
      url: `${endpoint}`,
      data: body,
      headers: headers
        ? headers
        : {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
    });
  } catch (err) {
    console.log("err", err);
  }
}
